'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Spinner = require('./Spinner');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Spinner).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Spinner/index.js
// module id = 1294
// module chunks = 1